(function () {
  'use strict';

  var UPLOAD_URL = 'https://app.max-brenner.co.il/upload-img';
  var UPLOADS_BASE = 'https://app.max-brenner.co.il/uploads/';
  var MAX_SIZE = 5 * 1024 * 1024; // 5MB
  var PROPERTY_NAME = 'properties[Image]';

  // The product-form whose submit we intercepted and are waiting to complete.
  var pendingForm = null;

  function getPopup() {
    return document.getElementById('uploadImagePopup');
  }

  function setError(message) {
    var el = document.getElementById('imgError');
    if (el) el.textContent = message || '';
  }

  function resetPopupState() {
    var fileInput = document.getElementById('imageInput');
    var fileName = document.getElementById('fileName');
    if (fileInput) fileInput.value = '';
    if (fileName) fileName.textContent = 'לא נבחר קובץ';
    setError('');
  }

  function setLoading(isLoading) {
    var btn = document.getElementById('addImageBtn');
    if (!btn) return;
    btn.classList.toggle('btn--loading', isLoading);
    btn.toggleAttribute('aria-disabled', isLoading);
  }

  // Capture-phase guard: block ProductForm's own submit handler for upsell
  // products that require an image, until the image has been uploaded.
  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form || form.getAttribute('data-image-upload') !== 'true') return;
      if (form.getAttribute('data-image-uploaded') === 'true') return; // already handled, let it through

      event.preventDefault();
      event.stopImmediatePropagation();

      pendingForm = form;
      resetPopupState();
      // Drop any stale property input from a previous attempt.
      var stale = form.querySelector('input[name="' + PROPERTY_NAME + '"]');
      if (stale) stale.remove();

      var popup = getPopup();
      if (popup && typeof popup.show === 'function') {
        popup.show();
      }
    },
    true
  );

  // Reflect the chosen filename in the label.
  document.addEventListener('change', function (event) {
    if (event.target && event.target.id === 'imageInput') {
      var fileName = document.getElementById('fileName');
      var file = event.target.files && event.target.files[0];
      if (fileName) fileName.textContent = file ? file.name : 'לא נבחר קובץ';
      setError('');
    }
  });

  // Confirm: validate, upload, attach property, re-submit the original form.
  document.addEventListener('click', function (event) {
    var btn = event.target.closest ? event.target.closest('#addImageBtn') : null;
    if (!btn) return;
    if (btn.hasAttribute('aria-disabled')) return;

    var fileInput = document.getElementById('imageInput');
    var file = fileInput && fileInput.files ? fileInput.files[0] : null;

    if (!file) {
      setError('אנא בחר קובץ תמונה');
      return;
    }
    if (file.size > MAX_SIZE) {
      setError('גודל הקובץ עולה על 5MB');
      return;
    }

    setError('');
    setLoading(true);

    var reader = new FileReader();
    reader.onload = function (e) {
      fetch(UPLOAD_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ imageBase64: e.target.result }),
      })
        .then(function (response) {
          if (!response.ok) throw new Error('upload failed');
          return response.json();
        })
        .then(function (data) {
          if (!data || !data.filePath) throw new Error('missing filePath');
          attachAndSubmit(UPLOADS_BASE + data.filePath);
        })
        .catch(function () {
          setLoading(false);
          setError('נראה שהתמונה גדולה מדי. אנא הקטן את הגודל ונסה שוב');
        });
    };
    reader.onerror = function () {
      setLoading(false);
      setError('נראה שהתמונה גדולה מדי. אנא הקטן את הגודל ונסה שוב');
    };
    reader.readAsDataURL(file);
  });

  function attachAndSubmit(imageUrl) {
    var form = pendingForm;
    if (!form) {
      setLoading(false);
      return;
    }

    var input = document.createElement('input');
    input.type = 'hidden';
    input.name = PROPERTY_NAME;
    input.value = imageUrl;
    form.appendChild(input);

    form.setAttribute('data-image-uploaded', 'true');

    setLoading(false);

    var popup = getPopup();
    if (popup && typeof popup.hide === 'function') {
      popup.hide();
    }
    resetPopupState();
    pendingForm = null;

    var submitBtn = form.querySelector('[type="submit"]');
    if (form.requestSubmit) {
      form.requestSubmit(submitBtn || undefined);
    } else if (submitBtn) {
      submitBtn.click();
    } else {
      form.submit();
    }

    // Allow this same upsell to be customized again on a later add.
    setTimeout(function () {
      form.removeAttribute('data-image-uploaded');
      if (input && input.parentNode) input.parentNode.removeChild(input);
    }, 0);
  }
})();
